import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import IGIcon from '../assets/image/IG.jpeg';
import FBIcon from '../assets/image/fb.jpeg';
import TWIcon from '../assets/image/tw.jpeg';
import PIIcon from '../assets/image/PI.jpeg';

const FooterWrapper = styled.footer`
  background: ${props => props.theme.colors.primary};
  color: white;
  padding: 80px 40px 30px;
`;

const FooterContent = styled.div`
  max-width: ${props => props.theme.spacing.container};
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 50px;
  align-items: start;
  
  @media (max-width: 968px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  
  h4 {
    color: ${props => props.theme.colors.secondary};
    margin-bottom: 25px;
    font-size: 15px;
    letter-spacing: 2px;
    font-weight: 500;
    text-transform: uppercase;
    text-align: left;
  }
  
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  li {
    margin-bottom: 12px;
  }
  
  a, span {
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
    line-height: 1.8;
    transition: all ${props => props.theme.transitions.fast};
    cursor: pointer;
    display: block;
    text-align: left;
    
    &:hover {
      color: ${props => props.theme.colors.secondary};
      padding-left: 5px;
    }
  }
  
  p {
    color: rgba(255, 255, 255, 0.7);
    line-height: 1.8;
    font-size: 14px;
    text-align: left;
    margin: 0;
    padding: 0;
  }
`;

const BrandSection = styled.div`
  grid-column: span 1;
  
  @media (max-width: 576px) {
    grid-column: span 1;
  }
`;

const BrandName = styled.h3`
  font-size: 28px;
  color: white;
  margin-bottom: 20px;
  font-weight: 400;
  letter-spacing: 3px;
`;

const BrandTagline = styled.p`
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  line-height: 1.8;
  margin-bottom: 25px;
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 15px;
`;

const SocialIcon = styled.span`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all ${props => props.theme.transitions.medium};
  
  img {
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }
  
  &:hover {
    background: ${props => props.theme.colors.secondary};
    transform: translateY(-3px);
  }
`;

const Divider = styled.div`
  max-width: ${props => props.theme.spacing.container};
  margin: 50px auto 30px;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent);
`;

const Copyright = styled.div`
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
  letter-spacing: 0.5px;
`;

const Footer = () => {
  return (
    <FooterWrapper>
      <FooterContent>
        <BrandSection>
          <BrandName>CEY-VALORA</BrandName>
          <BrandTagline>
            Curating the world's finest gemstones since 2026. 
            Exceptional quality, ethical sourcing, and timeless elegance.
          </BrandTagline>
          <SocialLinks>
            <SocialIcon>
              <img src={IGIcon} alt="Instagram" />
            </SocialIcon>
            <SocialIcon>
              <img src={FBIcon} alt="Facebook" />
            </SocialIcon>
            <SocialIcon>
              <img src={TWIcon} alt="Twitter" />
            </SocialIcon>
            <SocialIcon>
              <img src={PIIcon} alt="Pinterest" />
            </SocialIcon>
          </SocialLinks>
        </BrandSection>
        
        <FooterSection>
          <h4>Explore</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/premium">Premium Collection</Link></li>
            <li><Link to="/fine-gems">Fine Gems</Link></li>
            <li><Link to="/precious-gems">Precious Gems</Link></li>
            <li><Link to="/tourmaline">Tourmaline</Link></li>
            <li><Link to="/garnets">Garnets</Link></li>
          </ul>
        </FooterSection>
        
        <FooterSection>
          <h4>Services</h4>
          <ul>
            <li><span>Custom Jewelry</span></li>
            <li><span>Gemstone Consultation</span></li>
            <li><span>Investment Advisory</span></li>
            <li><span>Certification</span></li>
            <li><span>Appraisals</span></li>
          </ul>
        </FooterSection>
        
        <FooterSection>
          <h4>Contact</h4>
          <ul>
            <li><span>Atlanta, Georgia</span></li>
            <li><span>+1 (470) 670-7456</span></li>
            <li><span>info@ceyvalora.com</span></li>
          </ul>
        </FooterSection>
      </FooterContent>
      
      <Divider />
      
      <Copyright>
        © 2026 Cey-Valora Gems USA. All rights reserved. | Ethically Sourced
        {' '}|{' '}
        <a
          href="https://vastfactor.io"
          target="_blank"
          rel="noreferrer"
          style={{ color: 'inherit', textDecoration: 'underline' }}
        >
          Powered by VastFactor
        </a>
      </Copyright>

    </FooterWrapper>
  );
};

export default Footer;
